import { Attr, HasOne, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Organisation from "./Organisation";

@Model()
class TranscriptTurnaroundTime extends ApplicationRecord {
  static jsonapiType = "transcript_turnaround_times";

  @Attr({ persist: false }) createdAt: string;

  @HasOne() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() transcriptMinutes: number;

  @Attr() turnaroundMinutes: number;

  @Attr({ persist: false }) updatedAt: string;
}

export default TranscriptTurnaroundTime;
